const WhiteStarIcon = ({ size = "12" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M10.1396 4.13438L7.1642 3.70196L5.83412 1.00547C5.79779 0.931645 5.73803 0.871879 5.6642 0.835551C5.47904 0.744145 5.25404 0.820317 5.16147 1.00547L3.83139 3.70196L0.855997 4.13438C0.773966 4.1461 0.698966 4.18477 0.641544 4.24336C0.572124 4.31472 0.533871 4.41071 0.535189 4.51025C0.536508 4.60979 0.57729 4.70474 0.648575 4.77422L2.80131 6.87305L2.29272 9.83672C2.28079 9.90566 2.28842 9.97657 2.31474 10.0414C2.34106 10.1062 2.38501 10.1624 2.44162 10.2035C2.49823 10.2446 2.56523 10.269 2.63502 10.274C2.70481 10.279 2.7746 10.2643 2.83647 10.2316L5.49779 8.83243L8.15912 10.2316C8.23178 10.2703 8.31615 10.2832 8.39701 10.2691C8.60092 10.234 8.73803 10.0406 8.70287 9.83672L8.19428 6.87305L10.347 4.77422C10.4056 4.7168 10.4443 4.6418 10.456 4.55977C10.4876 4.35469 10.3447 4.16485 10.1396 4.13438Z"
      fill="white"
    />
  </svg>
);
export default WhiteStarIcon;
